import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class EnrollSessionService {
  data: any;
  mobileView: boolean;
  SummaryCartMobOnly: boolean;
  submitApplicationData: any;
  mediumScreen: any;
  editTransformationPack: any;
  SessionKey:string;
  productList:any = [];

  // Constants for cart persistence
  private readonly CART_EXPIRY_HOURS = 48;
  private readonly CART_TIMESTAMP_KEY = 'CartTimestamp';

  customerImage:any;
    constructor(private _activateRoute: ActivatedRoute) {
      // this.data = localStorage.getItem('EnrollSession') ? JSON.parse(localStorage.getItem('EnrollSession')) : {};
       // Check and load cart data with expiration check
    this.data = this.loadCartWithExpirationCheck();
      this.submitApplicationData = JSON.parse(sessionStorage.getItem('submitApplicationData')) ? JSON.parse(sessionStorage.getItem('submitApplicationData')) : {};
      this.editTransformationPack = sessionStorage.getItem('editTransformationPack') ? sessionStorage.getItem('editTransformationPack') : '';
    }  
    /**
   * Load cart data from localStorage with expiration check for non-logged-in users
   */
  private loadCartWithExpirationCheck(): any {
    try {
      const enrollSessionData = localStorage.getItem('EnrollSession');
      const cartTimestamp = localStorage.getItem(this.CART_TIMESTAMP_KEY);
      
      if (!enrollSessionData) {
        return {};
      }
      
      const parsedData = JSON.parse(enrollSessionData);
      
      // If user is logged in, return data without expiration check
      if (parsedData.IsLoggedIn || this.isUserLoggedIn()) {
        return parsedData;
      }
      
      // For non-logged-in users, check cart expiration
      if (cartTimestamp) {
        const timestampDate = new Date(cartTimestamp);
        const currentDate = new Date();
        const hoursDifference = (currentDate.getTime() - timestampDate.getTime()) / (1000 * 60 * 60);
        
        if (hoursDifference > this.CART_EXPIRY_HOURS) {
          // Cart has expired, clear it
          console.log('Cart expired after 48 hours, clearing cart data');
          this.clearExpiredCart();
          return {};
        }
      }
      
      return parsedData;
    } catch (error) {
      console.error('Error loading cart data:', error);
      return {};
    }
  }
  
  /**
   * Check if user is currently logged in
   */
  private isUserLoggedIn(): boolean {
    try {
      const authToken = localStorage.getItem('authtoken');
      return authToken !== null;
    } catch {
      return false;
    }
  }
  
  /**
   * Clear expired cart data from localStorage
   */
  private clearExpiredCart(): void {
    try {
      localStorage.removeItem('EnrollSession');
      localStorage.removeItem(this.CART_TIMESTAMP_KEY);
    } catch (error) {
      console.error('Error clearing expired cart:', error);
    }
  }
  
  /**
   * Save cart data with timestamp for non-logged-in users
   */
  saveCartData(): void {
    try {
      // Save the enrollment session data
      localStorage.setItem('EnrollSession', JSON.stringify(this.data));
      
      // For non-logged-in users, save timestamp
      if (!this.data.IsLoggedIn && !this.isUserLoggedIn()) {
        const currentTimestamp = new Date().toISOString();
        localStorage.setItem(this.CART_TIMESTAMP_KEY, currentTimestamp);
      }
    } catch (error) {
      console.error('Error saving cart data:', error);
    }
  }
  
  /**
   * Set cart timestamp when first item is added for non-logged-in users
   */
  setCartTimestampIfNeeded(): void {
    try {
      const existingTimestamp = localStorage.getItem(this.CART_TIMESTAMP_KEY);
      
      // Only set timestamp if user is not logged in and timestamp doesn't exist
      if (!this.data.IsLoggedIn && !this.isUserLoggedIn() && !existingTimestamp) {
        const currentTimestamp = new Date().toISOString();
        localStorage.setItem(this.CART_TIMESTAMP_KEY, currentTimestamp);
      }
    } catch (error) {
      console.error('Error setting cart timestamp:', error);
    }
  }
  
  /**
   * Clear cart timestamp when user logs in
   */
  clearCartTimestamp(): void {
    try {
      localStorage.removeItem(this.CART_TIMESTAMP_KEY);
    } catch (error) {
      console.error('Error clearing cart timestamp:', error);
    }
  }
  
  /**
   * Get remaining time before cart expires (in hours)
   */
  getCartExpirationTime(): number | null {
    try {
      const cartTimestamp = localStorage.getItem(this.CART_TIMESTAMP_KEY);
      
      if (!cartTimestamp || this.data.IsLoggedIn || this.isUserLoggedIn()) {
        return null;
      }
      
      const timestampDate = new Date(cartTimestamp);
      const currentDate = new Date();
      const hoursDifference = (currentDate.getTime() - timestampDate.getTime()) / (1000 * 60 * 60);
      const remainingHours = this.CART_EXPIRY_HOURS - hoursDifference;
      
      return Math.max(0, remainingHours);
    } catch (error) {
      console.error('Error getting cart expiration time:', error);
      return null;
    }
  }
    resetEnrollSessionServiceData(page): any {
      if(this.editTransformationPack != 'true') {
        this.data = {};
        if (this.data && Object.keys(this.data).length === 0) {
            this.data.IsShowCart = false;
            this.data.page = page;
            this.data.TotalItemLength = 0;
            this.data.RetailEnroll = {};
            this.data.InitOrder = [];
            this.data.InitialOrdersSubTotal = 0;
            this.data.RetailOrderSummary = {};
            this.data.RetailOrderSummary.Enrollpack = [];
            this.data.EligibleForFreeUpgrade = false;
            this.data.RetailEnroll.ShippingMethod = '';
            this.data.usePrimaryCard = null;
            this.data.primaryCreditCardField = {};
            this.data.EnrollmentType = this.data.EnrollmentType || 1;
            this.data.IsLoggedIn=false;
            this.data.LoggedInUserData={};
            this.data.IsUpGrade =
                this._activateRoute.snapshot.queryParamMap.get('customerId') ? this._activateRoute.snapshot.queryParamMap.get('customerId') : false;
            if (this.data.IsUpGrade) {
                localStorage.setItem('customerId', this.data.IsUpGrade);
            }
            this.data.Volume109 = 0;
            this.data.SmartOrderBVTotal = 0;
            this.data.smartOrderDate = 0;
            this.data.InitialOrdersQVTotal = 0;
            this.data.AddOnOrdersQVTotal = 0;
        }
      }  
    }

    removeValidators(form: FormGroup, formControl: any) {
      form.get(formControl).clearValidators();
      form.get(formControl).updateValueAndValidity();
    }
    addValidators(form: FormGroup, formControl: any) {
      form.get(formControl).setValidators([Validators.required, trimValidator]);
      form.get(formControl).updateValueAndValidity();
  }
  mobileViewMethod(){
    let screenWidth = window.innerWidth
    if(screenWidth < 551){
      return true;
    }
    else{
      return false;
    }
  }
}
const trimValidator: ValidatorFn = (control: FormControl) => {
  if (control && control.value && typeof control.value == "string" && !control.value.replace(/\s/g, '').length) {
      return {
          'trimError': { value: 'control has leading whitespace' }
      };
  }

  return null;
};
